var map = {
	"./1": 122,
	"./1.png": 122,
	"./2": 123,
	"./2.png": 123,
	"./3": 124,
	"./3.png": 124,
	"./4": 125,
	"./4.png": 125,
	"./about": 126,
	"./about.png": 126,
	"./activity": 222,
	"./activity.svg": 222,
	"./add-cta": 289,
	"./add-cta-active": 290,
	"./add-cta-active.svg": 290,
	"./add-cta.svg": 289,
	"./added-to-collections-active": 291,
	"./added-to-collections-active.svg": 291,
	"./adobe": 127,
	"./adobe.png": 127,
	"./analytics": 105,
	"./analytics.svg": 105,
	"./annotate": 292,
	"./annotate-active": 293,
	"./annotate-active.svg": 293,
	"./annotate.svg": 292,
	"./annotate/arrow": 255,
	"./annotate/arrow.svg": 255,
	"./annotate/crop": 256,
	"./annotate/crop.svg": 256,
	"./annotate/draw": 257,
	"./annotate/draw.svg": 257,
	"./annotate/ellipse": 258,
	"./annotate/ellipse-focus": 259,
	"./annotate/ellipse-focus.svg": 259,
	"./annotate/ellipse.svg": 258,
	"./annotate/emoji": 111,
	"./annotate/emoji.png": 111,
	"./annotate/emoji@2x": 112,
	"./annotate/emoji@2x.png": 112,
	"./annotate/emoji@3x": 113,
	"./annotate/emoji@3x.png": 113,
	"./annotate/highlighter": 260,
	"./annotate/highlighter.svg": 260,
	"./annotate/line": 261,
	"./annotate/line.svg": 261,
	"./annotate/number": 262,
	"./annotate/number.svg": 262,
	"./annotate/pixelate": 263,
	"./annotate/pixelate.svg": 263,
	"./annotate/rect": 264,
	"./annotate/rect.svg": 264,
	"./annotate/square-focus": 265,
	"./annotate/square-focus.svg": 265,
	"./annotate/text": 266,
	"./annotate/text.svg": 266,
	"./annotate/tools-history-back": 267,
	"./annotate/tools-history-back-disabled": 268,
	"./annotate/tools-history-back-disabled.svg": 268,
	"./annotate/tools-history-back.svg": 267,
	"./annotate/tools-history-forward": 269,
	"./annotate/tools-history-forward-disabled": 270,
	"./annotate/tools-history-forward-disabled.svg": 270,
	"./annotate/tools-history-forward.svg": 269,
	"./annotate/tools-zoom-zoom-in": 253,
	"./annotate/tools-zoom-zoom-in.svg": 253,
	"./annotate/tools-zoom-zoom-out": 254,
	"./annotate/tools-zoom-zoom-out.svg": 254,
	"./app-icon": 294,
	"./app-icon.svg": 294,
	"./apple": 295,
	"./apple.svg": 295,
	"./apple_logo": 208,
	"./apple_logo.svg": 208,
	"./arrow-big": 128,
	"./arrow-big.png": 128,
	"./atlassian": 129,
	"./atlassian.png": 129,
	"./bg-bottom": 130,
	"./bg-bottom.png": 130,
	"./bg-top": 131,
	"./bg-top.png": 131,
	"./bill": 296,
	"./bill.svg": 296,
	"./blurred-drop": 87,
	"./blurred-drop.png": 87,
	"./branding": 106,
	"./branding.svg": 106,
	"./buttons-add-new-collection-hover": 297,
	"./buttons-add-new-collection-hover.svg": 297,
	"./buttons-add-new-collection-sidebar": 298,
	"./buttons-add-new-collection-sidebar.svg": 298,
	"./card-generic": 99,
	"./card-generic.png": 99,
	"./check-mark": 299,
	"./check-mark.svg": 299,
	"./checkmark": 300,
	"./checkmark.svg": 300,
	"./checkmark@2x": 132,
	"./checkmark@2x.png": 132,
	"./chrome": 301,
	"./chrome.svg": 301,
	"./close": 273,
	"./close.svg": 273,
	"./cloud-loader": 238,
	"./cloud-loader.gif": 238,
	"./cloudapp": 133,
	"./cloudapp-favicon": 134,
	"./cloudapp-favicon.png": 134,
	"./cloudapp-icon": 135,
	"./cloudapp-icon.png": 135,
	"./cloudapp-logo-horizontal": 209,
	"./cloudapp-logo-horizontal.svg": 209,
	"./cloudapp.png": 133,
	"./coach-mark": 302,
	"./coach-mark.svg": 302,
	"./collection": 223,
	"./collection.svg": 223,
	"./conversation": 303,
	"./conversation.svg": 303,
	"./dashboard": 224,
	"./dashboard.svg": 224,
	"./download-arrow": 304,
	"./download-arrow.svg": 304,
	"./download-chrome": 305,
	"./download-chrome.svg": 305,
	"./download-cloud": 306,
	"./download-cloud.svg": 306,
	"./download-drop": 307,
	"./download-drop.svg": 307,
	"./download-mac": 308,
	"./download-mac.svg": 308,
	"./download-windows": 309,
	"./download-windows.svg": 309,
	"./download_icon_chrome": 310,
	"./download_icon_chrome.svg": 310,
	"./download_icon_mac": 311,
	"./download_icon_mac.svg": 311,
	"./download_icon_windows": 312,
	"./download_icon_windows.svg": 312,
	"./email": 210,
	"./email.svg": 210,
	"./enterprise@2x": 136,
	"./enterprise@2x.png": 136,
	"./file-placeholder": 271,
	"./file-placeholder.svg": 271,
	"./free@2x": 137,
	"./free@2x.png": 137,
	"./free_plan_icon": 138,
	"./free_plan_icon.png": 138,
	"./gift": 239,
	"./gift.svg": 239,
	"./google_logo": 211,
	"./google_logo.svg": 211,
	"./hat-icon": 313,
	"./hat-icon.svg": 313,
	"./hero-asset": 88,
	"./hero-asset.gif": 464,
	"./hero-asset.png": 88,
	"./icon-clock": 212,
	"./icon-clock.jpeg": 212,
	"./icon-get-cloudapp": 180,
	"./icon-get-cloudapp.svg": 180,
	"./icon-muted": 272,
	"./icon-muted.svg": 272,
	"./icon-muted@2x": 139,
	"./icon-muted@2x.png": 139,
	"./icons-add": 240,
	"./icons-add-bordered": 140,
	"./icons-add-bordered.png": 140,
	"./icons-add-to-collection-solid": 314,
	"./icons-add-to-collection-solid.svg": 314,
	"./icons-add.svg": 240,
	"./icons-announcement": 315,
	"./icons-announcement.svg": 315,
	"./icons-bug": 316,
	"./icons-bug.svg": 316,
	"./icons-card-actions-compact-read-only": 100,
	"./icons-card-actions-compact-read-only.svg": 100,
	"./icons-clipboard": 241,
	"./icons-clipboard.svg": 241,
	"./icons-conversation": 107,
	"./icons-conversation.svg": 107,
	"./icons-download-bordered": 141,
	"./icons-download-bordered.png": 141,
	"./icons-download-solid": 317,
	"./icons-download-solid.svg": 317,
	"./icons-edit-minimal": 213,
	"./icons-edit-minimal.svg": 213,
	"./icons-embed-bordered": 142,
	"./icons-embed-bordered.png": 142,
	"./icons-embed-solid": 318,
	"./icons-embed-solid.svg": 318,
	"./icons-hidden": 319,
	"./icons-hidden.svg": 319,
	"./icons-invite-active": 225,
	"./icons-invite-active.svg": 225,
	"./icons-invite-default": 226,
	"./icons-invite-default.svg": 226,
	"./icons-locked-bordered": 143,
	"./icons-locked-bordered.png": 143,
	"./icons-magic": 320,
	"./icons-magic.svg": 320,
	"./icons-mouse-click": 321,
	"./icons-mouse-click-gray": 322,
	"./icons-mouse-click-gray.svg": 322,
	"./icons-mouse-click.svg": 321,
	"./icons-new": 144,
	"./icons-new-gray": 242,
	"./icons-new-gray.svg": 242,
	"./icons-new-transparent": 243,
	"./icons-new-transparent.svg": 243,
	"./icons-new-white": 244,
	"./icons-new-white.svg": 244,
	"./icons-new.svg": 144,
	"./icons-notifications": 108,
	"./icons-notifications-active": 109,
	"./icons-notifications-active.svg": 109,
	"./icons-notifications.svg": 108,
	"./icons-rainbow-circle": 145,
	"./icons-rainbow-circle.png": 145,
	"./icons-rounded-corners": 323,
	"./icons-rounded-corners.svg": 323,
	"./icons-sales": 324,
	"./icons-sales.svg": 324,
	"./icons-search": 325,
	"./icons-search.svg": 325,
	"./icons-settings-blue": 245,
	"./icons-settings-blue.svg": 245,
	"./icons-settings-gray": 214,
	"./icons-settings-gray.svg": 214,
	"./icons-share-settings-locked": 326,
	"./icons-share-settings-locked.svg": 326,
	"./icons-slightly-rounded-corners": 327,
	"./icons-slightly-rounded-corners.svg": 327,
	"./icons-square-corners": 328,
	"./icons-square-corners.svg": 328,
	"./icons-support": 329,
	"./icons-support.svg": 329,
	"./icons-toggle-close": 246,
	"./icons-toggle-close.svg": 246,
	"./icons-toggle-open": 247,
	"./icons-toggle-open.svg": 247,
	"./icons-transcribe": 215,
	"./icons-transcribe.svg": 215,
	"./illustrations-transcription-processing": 248,
	"./illustrations-transcription-processing.svg": 248,
	"./indicator-right": 330,
	"./indicator-right.svg": 330,
	"./infinite": 110,
	"./infinite.svg": 110,
	"./installer": 331,
	"./installer.svg": 331,
	"./logo-visa": 332,
	"./logo-visa.jpeg": 332,
	"./logo@2x": 80,
	"./logo@2x-blue": 146,
	"./logo@2x-blue.png": 146,
	"./logo@2x.png": 80,
	"./logos-cloud-app-logomark-full-color": 216,
	"./logos-cloud-app-logomark-full-color.svg": 216,
	"./main-banner": 147,
	"./main-banner.png": 147,
	"./menu-bar": 333,
	"./menu-bar.svg": 333,
	"./onboarding/apple": 181,
	"./onboarding/apple.svg": 181,
	"./onboarding/bill": 148,
	"./onboarding/bill.svg": 148,
	"./onboarding/chrome": 182,
	"./onboarding/chrome.svg": 182,
	"./onboarding/download-arrow": 183,
	"./onboarding/download-arrow.svg": 183,
	"./onboarding/download-chrome": 184,
	"./onboarding/download-chrome.svg": 184,
	"./onboarding/download-drop": 185,
	"./onboarding/download-drop.svg": 185,
	"./onboarding/download-mac": 186,
	"./onboarding/download-mac.svg": 186,
	"./onboarding/download-windows": 187,
	"./onboarding/download-windows.svg": 187,
	"./onboarding/email": 149,
	"./onboarding/email.svg": 149,
	"./onboarding/hat-icon": 188,
	"./onboarding/hat-icon.svg": 188,
	"./onboarding/icons-check": 101,
	"./onboarding/icons-check.svg": 101,
	"./onboarding/icons-chrome-desaturated": 189,
	"./onboarding/icons-chrome-desaturated.svg": 189,
	"./onboarding/icons-cloud-app-app": 190,
	"./onboarding/icons-cloud-app-app.svg": 190,
	"./onboarding/icons-download": 150,
	"./onboarding/icons-download.svg": 150,
	"./onboarding/icons-extension": 151,
	"./onboarding/icons-extension.svg": 151,
	"./onboarding/installer": 191,
	"./onboarding/installer.svg": 191,
	"./onboarding/menu-bar": 192,
	"./onboarding/menu-bar.svg": 192,
	"./onboarding/start": 152,
	"./onboarding/start.svg": 152,
	"./onboarding/windows": 193,
	"./onboarding/windows.svg": 193,
	"./parallax": 334,
	"./parallax.jpg": 334,
	"./pattern": 153,
	"./pattern-2": 154,
	"./pattern-2.png": 154,
	"./pattern-4": 155,
	"./pattern-4.png": 155,
	"./pattern.png": 153,
	"./plus": 335,
	"./plus-small": 336,
	"./plus-small.svg": 336,
	"./plus.svg": 335,
	"./prize": 337,
	"./prize.svg": 337,
	"./prize@2x": 93,
	"./prize@2x.png": 93,
	"./pro-badge": 194,
	"./pro-badge.svg": 194,
	"./pro-ribbon": 79,
	"./pro-ribbon.png": 79,
	"./pro-ribbon.svg": 465,
	"./pro@1x": 156,
	"./pro@1x.png": 156,
	"./pro@2x": 102,
	"./pro@2x.png": 102,
	"./pro@3x": 157,
	"./pro@3x.png": 157,
	"./pro_plan_icon": 158,
	"./pro_plan_icon.png": 158,
	"./salesforce": 159,
	"./salesforce.png": 159,
	"./seats-left": 338,
	"./seats-left.svg": 338,
	"./spinner": 55,
	"./spinner.svg": 55,
	"./start": 339,
	"./start.svg": 339,
	"./team": 217,
	"./team-3": 340,
	"./team-3.jpg": 340,
	"./team.svg": 217,
	"./team@2x": 103,
	"./team@2x.png": 103,
	"./team_plan_icon": 160,
	"./team_plan_icon.png": 160,
	"./team_sidebar": 161,
	"./team_sidebar.png": 161,
	"./thumbnail": 162,
	"./thumbnail.png": 162,
	"./upload-arrow": 341,
	"./upload-arrow.svg": 341,
	"./upload-cloud": 342,
	"./upload-cloud.svg": 342,
	"./upload-copy": 163,
	"./upload-copy.png": 163,
	"./upload-copy@2x": 164,
	"./upload-copy@2x.png": 164,
	"./upload-copy@3x": 165,
	"./upload-copy@3x.png": 165,
	"./upload-drop": 343,
	"./upload-drop.svg": 343,
	"./video-thumbnail": 166,
	"./video-thumbnail.png": 166,
	"./video-trim": 344,
	"./video-trim-active": 345,
	"./video-trim-active.svg": 345,
	"./video-trim.svg": 344,
	"./view-grid": 346,
	"./view-grid-active": 347,
	"./view-grid-active.svg": 347,
	"./view-grid.svg": 346,
	"./view-list": 348,
	"./view-list-active": 349,
	"./view-list-active.svg": 349,
	"./view-list.svg": 348,
	"./windows": 350,
	"./windows.svg": 350,
	"./your_plan_badge@2x": 167,
	"./your_plan_badge@2x.png": 167,
	"./zendesk": 168,
	"./zendesk.png": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 420;